import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ConfigReportEditState,
  Signal,
} from "../../../../utils/interfaces/store/IStore";
import { ConfigReport } from "../../../../utils/types/ConfigReport";
import { IPayloadSetError } from "../../../Interfaces";

const initialState: ConfigReportEditState = {
  form: {
    name: "",
    description: "",
    reportId: "",
  },
};

export const ConfigReportEditSlice = createSlice({
  name: "ConfigReportEdit",
  initialState,
  reducers: {
    clean: (_, action: PayloadAction<undefined>) => {
      return {
        ...initialState,
        action: { ...action } as any,
      } as ConfigReportEditState;
    },
    setForm: (state, action: PayloadAction<{ id: string; value: string }>) => {
      const { id, value } = action.payload;

      return {
        ...state,
        action: { ...action } as any,
        form: {
          ...state.form,
          [id]: value,
        },
      } as ConfigReportEditState;
    },
    getOne: (state, action: PayloadAction<undefined>) => {
      return {
        ...state,
        action: { ...action } as any,
      } as ConfigReportEditState;
    },
    getOneSuccess: (state, action: PayloadAction<ConfigReport>) => {
      return {
        ...state,
        action: { ...action } as any,
        form: action.payload,
      } as ConfigReportEditState;
    },
    getOneError: (state, action: PayloadAction<IPayloadSetError>) => {
      return {
        ...state,
        action: { ...action } as any,
      } as ConfigReportEditState;
    },
    save: (state, action: PayloadAction<undefined>) => {
      return {
        ...state,
        action: { ...action } as any,
        updated: Signal.loading(),
      } as ConfigReportEditState;
    },
    saveSuccess: (state, action: PayloadAction<ConfigReport>) => {
      return {
        ...state,
        action: { ...action } as any,
        updated: Signal.success(action.payload),
      } as ConfigReportEditState;
    },
    saveError: (state, action: PayloadAction<IPayloadSetError>) => {
      return {
        ...state,
        action: { ...action } as any,
        updated: Signal.error(action.payload.error, action.payload.shorterror),
      } as ConfigReportEditState;
    },
  },
});
